/** @jsx h */
import { useRef } from 'preact/hooks';
import { labels } from '../config';

const Sorting = ({ sorting, triggerAjaxSubmit, pluginNamespace }) => {
  const sortingInputEl = useRef(null);

  function getSortingLabel(option) {
    if (option.isAscDirection) {
      return labels.sorting.sortByAsc;
    } else {
      return labels.sorting.sortByDesc;
    }
  }

  function handleSortingClick(e) {
    const button = e.currentTarget;
    const value = button.dataset.value;

    // replace old sorting with new one and submit form
    if (sortingInputEl && sortingInputEl.current) {
      sortingInputEl.current.value = value;
    }
    triggerAjaxSubmit();
  }

  return (
    <div className="search-section__filter-sort">
      <label htmlFor="sorting" className="sorting__input is-hidden">
        <input
          id="sorting"
          name={`${pluginNamespace}[sort]`}
          type="text"
          readOnly
          ref={sortingInputEl}
        />
        <span>{labels.sorting.sortBy}</span>
      </label>
      <span>{labels.sorting.sortBy}</span>
      {sorting.length
        ? sorting.map(option => (
            <div key={option.name}>
              <button
                className="btn"
                aria-pressed={option.selected}
                data-direction={option.sortingDirection}
                data-value={
                  option.isResetOption
                    ? ''
                    : `${option.name} ${option.sortingDirection}`
                }
                onClick={handleSortingClick}
                type="button"
              >
                <span>{getSortingLabel(option)}</span>
                <svg
                  className="svg-chevron-down"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                >
                  <path
                    fill="currentColor"
                    d="M 7,8.167306 12.444903,2.722403 14,4.2775 l -7,7 -7,-7 1.5550972,-1.555097 z"
                  />
                </svg>
              </button>
            </div>
          ))
        : ''}
    </div>
  );
};

export default Sorting;
